import { ELIGIBILITY_TYPE } from '../const/eligibilityType';
import { INELIGIBLE_REASON } from '../const/paymentEnterpriseEligibility';
const generateEligibilityDetailParseFn = (eligibilityType) => {
    return (paymentEnterpriseEligibility, subEligibilityType) => {
        var _a;
        return (_a = paymentEnterpriseEligibility[eligibilityType]) === null || _a === void 0 ? void 0 : _a.find(({ subEligibilityType: subType }) => subType === subEligibilityType);
    };
};
export const getAutopayEligibilityDetail = generateEligibilityDetailParseFn(ELIGIBILITY_TYPE.AUTOPAY);
export const getOneTimePaymentEligibilityDetail = generateEligibilityDetailParseFn(ELIGIBILITY_TYPE.ONE_TIME_PAYMENT);
export const getPaymentOptionEligibilityDetail = generateEligibilityDetailParseFn(ELIGIBILITY_TYPE.PAYMENT_OPTION);
export const getAutopayIneligibleCriteria = (paymentEnterpriseEligibility, subEligibilityType) => {
    const eligibilityDetail = getAutopayEligibilityDetail(paymentEnterpriseEligibility, subEligibilityType);
    if (!(eligibilityDetail === null || eligibilityDetail === void 0 ? void 0 : eligibilityDetail.eligible)) {
        return eligibilityDetail === null || eligibilityDetail === void 0 ? void 0 : eligibilityDetail.criteria.find(({ attribute }) => {
            return attribute === 'reason';
        });
    }
    return null;
};
const isAvailableInEligibilityDetail = (paymentEnterpriseEligibility, paymentType, attribute) => {
    const eligibilityDetail = getPaymentOptionEligibilityDetail(paymentEnterpriseEligibility, paymentType);
    if (!eligibilityDetail) {
        return false;
    }
    return eligibilityDetail.criteria.some((criteria) => criteria.attribute === attribute && criteria.value === 'true');
};
export const isWaivedInterestOneTimePaymentEligible = (paymentEnterpriseEligibility) => isAvailableInEligibilityDetail(paymentEnterpriseEligibility, 'ONE_TIME_PAYMENT', 'WAIVED_INTEREST_AMOUNT');
export const isWaivedInterestAvailableForAutopay = (paymentEnterpriseEligibility) => isAvailableInEligibilityDetail(paymentEnterpriseEligibility, 'AUTOPAY', 'WAIVED_INTEREST_AMOUNT');
export const isWaivedInterestPayOffEligible = (paymentEnterpriseEligibility) => isAvailableInEligibilityDetail(paymentEnterpriseEligibility, 'ONE_TIME_PAYMENT', 'WAIVED_INTEREST_PAYOFF_AMOUNT');
export const isIntroRateLoanPromoAvailableForAutopay = (paymentEnterpriseEligibility) => isAvailableInEligibilityDetail(paymentEnterpriseEligibility, 'AUTOPAY', 'INTRO_LOAN_AMOUNT');
export const isAutopayEnrollmentEligible = (paymentEnterpriseEligibility) => {
    return getAutopayEligibilityDetail(paymentEnterpriseEligibility, 'AUTOPAY_ENROLL').eligible;
};
export const isAutopayModifyEligible = (paymentEnterpriseEligibility) => getAutopayEligibilityDetail(paymentEnterpriseEligibility, 'AUTOPAY_MODIFY')
    .eligible;
export const doesOneTimePaymentExist = (paymentEnterpriseEligibility) => {
    const eligibilityDetail = getOneTimePaymentEligibilityDetail(paymentEnterpriseEligibility, 'MAKE_A_PAYMENT');
    if (!(eligibilityDetail === null || eligibilityDetail === void 0 ? void 0 : eligibilityDetail.eligible)) {
        return eligibilityDetail === null || eligibilityDetail === void 0 ? void 0 : eligibilityDetail.criteria.some(({ value }) => {
            return value === INELIGIBLE_REASON.oneTimePaymentExists;
        });
    }
    return false;
};
